import { SUPPORTED_LANGUAGES } from '@/providers/TranslationProvider/constants';
import { FC } from 'react';
import s from './LanguagePill.module.scss';

const LanguagePill: FC<{ language: string | null, compact?: boolean }> = ({ language, compact }) => {
  const lang = SUPPORTED_LANGUAGES.find(l => l.code === language);

  if (!lang || lang.code === 'en') return null;

  return (
    <span className={s.pill}>{lang.flag} {compact ? lang.label.slice(0, 2) : lang.label}</span>
  );
};

export default LanguagePill;
